import React from 'react';

import { IconButton } from '@mui/material';
import { Trash2 } from 'lucide-react';
import { AlineTooltip } from 'src/components/generic';

const DELETE_AI_QUESTION_ICON_SIZE = 18;

export const ONLY_ADMINS_CAN_DELETE_AI_QUESTIONS = 'Only Admins can delete AI questions';

interface DeleteAiQuestionButtonProps {
  readonly canDelete: boolean;
  readonly onDelete: () => void;
}

export function DeleteAiQuestionButton({ canDelete, onDelete }: DeleteAiQuestionButtonProps) {
  const handleClick = () => {
    if (canDelete) onDelete();
  };

  return (
    <AlineTooltip
      arrow
      placement="top"
      title={canDelete ? 'Delete property' : ONLY_ADMINS_CAN_DELETE_AI_QUESTIONS}
    >
      <div>
        <IconButton
          aria-label="Delete AI question"
          disabled={!canDelete}
          size="small"
          onClick={handleClick}
        >
          <Trash2 size={DELETE_AI_QUESTION_ICON_SIZE} />
        </IconButton>
      </div>
    </AlineTooltip>
  );
}
